import Button from '@Atom/Button'
import DoodleGradientCard from '@Atom/DoodleGradientCard'
import { decryptStorageData } from '@Helpers/encryptDecrypt'
import { priceFormat } from '@Helpers/priceFormat'
import useWindowSize from '@Hooks/useWindowSize'
import Footer from '@Molecule/Footer'
import Table from '@Molecule/Table'
import Images from '@Theme/Images'
import { useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Styles from './style.module.scss'

export default function AdminTransactionLayout() {
  const user = decryptStorageData('user', localStorage)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(5)
  const [transactionType, setTransactionType] = useState('waiting-verification')

  const { width } = useWindowSize()


  const template = useMemo(() => {
    return {
      data: [
        {
          id: 1,
          classTitle: 'Mengelola Surat Menggunakan Sistem E-Filing untuk Sekretaris (Luring/Offline)',
          invoiceNumber: 'INV/122023/SKILLS/00000048',
          invoiceCode: 'INV-00001',
          price: 1450000
        }
      ],
      columns: [
        {
          name: 'classTitle',
          title: 'Judul Kelas',
          hideOnMobile: true,
        },
        {
          name: 'invoiceNumber',
          title: 'Nomor Invoice',
          renderData: (row) => (
            <span
              className={Styles.invoiceNumber}
              onClick={() => navigate(`${pathname}/${row?.invoiceCode}`)}
            >{row?.invoiceNumber}</span>
          )
        },
        {
          name: 'price',
          title: 'Harga Kelas',
          hideOnMobile: true,
          renderData: (row) => (
            <span>Rp{priceFormat(row?.price)}</span>
          )
        }
      ]
    }
  }, [navigate, pathname])

  const tabs = useMemo(() => {
    return [
      {
        title: 'Menunggu Verifikasi',
        type: 'waiting-verification'
      },
      {
        title: 'Transaksi Selesai',
        type: 'finished'
      },
      {
        title: 'Menunggu Pembayaran',
        type: 'waiting-payment'
      },
      {
        title: 'Transaksi Dibatalkan',
        type: 'canceled'
      }
    ]
  }, [])


  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <DoodleGradientCard className={Styles.header}>
          <div className={Styles.title}>
            <h3>Selamat Datang {<span>{user?.name}</span>}</h3>
            <span>Berikut adalah daftar seluruh transaksi di Skills.id</span>
          </div>
          {
            width > 768
            &&
            <img className={Styles.img} src={Images.MONEY_DOCUMENT} alt='' />
          }
        </DoodleGradientCard>
        <div className={Styles.tabs}>
          {
            tabs?.map((t, tI) => (
              <Button
                key={tI}
                text={t?.title}
                variant='tab'
                isActive={transactionType === t?.type}
                onClick={() => setTransactionType(t?.type)}
              />
            ))
          }

        </div>

        <Table
          data={template?.data}
          totalData={template?.data?.length}
          totalPage={3}
          columns={template?.columns}
          page={page}
          setPage={setPage}
          className={`${Styles.table} ${!template?.data?.length ? Styles.grow : ''}`}
          limit={limit}
          setLimit={setLimit}
          withNumbering
          expandComponent={(row) => (
            <div className={Styles.expandedInfo}>
              <div className={Styles.infoRow}>
                <span>Judul Kelas</span>
                <span>{row?.classTitle}</span>
              </div>
              <div className={Styles.infoRow}>
                <span>Harga</span>
                <span>Rp{priceFormat(row?.price)}</span>
              </div>

            </div>
          )}
        />
      </div>

      <Footer />
    </div>
  )
}